// export

export const postsPerPage = 10;
export const revalidate = parseInt(process.env.APP_REVALIDATE);
export const staleCache = parseInt(process.env.STALE_CACHE) * 1000;
export const siteUrl = process.env.RESOLVED_URL;
